import { render, staticRenderFns } from "./invoices-list.vue?vue&type=template&id=0df3567d&"
import script from "./invoices-list.vue?vue&type=script&lang=ts&"
export * from "./invoices-list.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-list.vue?vue&type=style&index=0&id=0df3567d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports